<template>
  <div class="container column">
    <header-operate></header-operate>
    <bread-crumb></bread-crumb>
    <router-view></router-view>
    <!--<ad-float></ad-float>-->
  </div>
</template>

<script>
import headerOperate from '@/components/header/operate.vue';
import breadCrumb from '@/components/header/breadCrumb.vue';

export default {
  components: {
    headerOperate,
    breadCrumb,
  },
};
</script>

<style>
</style>
